var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 39,
    viewBox: "0 0 133 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.932 38.9785H5.40123C2.70678 38.9785 0.5 36.8269 0.5 34.1998V5.52759C0.5 2.9005 2.70678 0.74889 5.40123 0.74889H127.932C130.627 0.74889 132.833 2.9005 132.833 5.52759V34.1998C132.833 36.8269 130.627 38.9785 127.932 38.9785Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.932 1.51468C130.201 1.51468 132.048 3.31505 132.048 5.52759V34.1998C132.048 36.4124 130.201 38.2127 127.932 38.2127H5.40123C3.13196 38.2127 1.28542 36.4124 1.28542 34.1998V5.52759C1.28542 3.31505 3.13196 1.51468 5.40123 1.51468H127.932ZM127.932 0.74889H5.40123C2.70678 0.74889 0.5 2.9005 0.5 5.52759V34.1998C0.5 36.8269 2.70678 38.9785 5.40123 38.9785H127.932C130.627 38.9785 132.833 36.8269 132.833 34.1998V5.52759C132.833 2.9005 130.627 0.74889 127.932 0.74889Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.729 7.95403C10.4411 8.24792 10.2744 8.70549 10.2744 9.29804V30.4342C10.2744 31.0268 10.4411 31.4844 10.729 31.7783L10.8001 31.8428L22.9478 20.0035V19.724L10.8001 7.88474L10.729 7.95403Z",
    fill: "url(#paint0_linear_7003_27507)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.992 23.9519L22.9473 20.0035V19.7239L26.9969 15.7755L27.0876 15.8269L31.8834 18.4875C33.2521 19.2425 33.2521 20.485 31.8834 21.2448L27.0876 23.9005L26.992 23.9519Z",
    fill: "url(#paint1_linear_7003_27507)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0876 23.9005L22.9473 19.8637L10.7285 31.7782C11.1831 32.2441 11.9244 32.3003 12.7674 31.8343L27.0876 23.9005Z",
    fill: "url(#paint2_linear_7003_27507)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0876 15.827L12.7674 7.89312C11.9244 7.43198 11.1831 7.48812 10.7285 7.95405L22.9473 19.8638L27.0876 15.827Z",
    fill: "url(#paint3_linear_7003_27507)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9813 10.5393C46.9813 11.3373 46.7363 11.9765 46.2535 12.4531C45.6984 13.0182 44.9755 13.3026 44.0896 13.3026C43.2429 13.3026 42.52 13.0134 41.9269 12.4436C41.3327 11.8654 41.0361 11.1557 41.0361 10.3063C41.0361 9.45689 41.3327 8.74725 41.9269 8.17381C42.52 7.59917 43.2429 7.31006 44.0896 7.31006C44.5111 7.31006 44.913 7.39488 45.2965 7.55258C45.6788 7.71147 45.9901 7.92651 46.2155 8.19173L45.7033 8.69588C45.31 8.2431 44.7746 8.0197 44.0896 8.0197C43.472 8.0197 42.9366 8.22996 42.482 8.65407C42.0323 9.07937 41.8068 9.63012 41.8068 10.3063C41.8068 10.9825 42.0323 11.538 42.482 11.9633C42.9366 12.3827 43.472 12.5977 44.0896 12.5977C44.7451 12.5977 45.2965 12.3827 45.7315 11.9585C46.0182 11.6778 46.1812 11.2907 46.2241 10.7961H44.0896V10.1056H46.9372C46.9715 10.2549 46.9813 10.3995 46.9813 10.5393Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4985 8.14531H48.8236V9.96122H51.2351V10.6517H48.8236V12.4676H51.4985V13.1713H48.0664V7.44165H51.4985V8.14531Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.687 13.1713H53.9298V8.14531H52.2891V7.44165H56.3289V8.14531H54.687V13.1713Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.252 13.1713V7.44165H60.008V13.1713H59.252Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3598 13.1713H62.6087V8.14531H60.9619V7.44165H65.0066V8.14531H63.3598V13.1713Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.655 12.434C72.0754 13.0134 71.3574 13.3026 70.5009 13.3026C69.6395 13.3026 68.9215 13.0134 68.3419 12.434C67.7635 11.8558 67.4756 11.1462 67.4756 10.3063C67.4756 9.46645 67.7635 8.75681 68.3419 8.17859C68.9215 7.59917 69.6395 7.31006 70.5009 7.31006C71.3525 7.31006 72.0705 7.59917 72.6501 8.18337C73.2333 8.76637 73.5213 9.47123 73.5213 10.3063C73.5213 11.1462 73.2333 11.8558 72.655 12.434ZM68.9018 11.9538C69.3381 12.3827 69.8686 12.5977 70.5009 12.5977C71.1282 12.5977 71.6637 12.3827 72.095 11.9538C72.53 11.5249 72.7505 10.9741 72.7505 10.3063C72.7505 9.63848 72.53 9.08774 72.095 8.65885C71.6637 8.22996 71.1282 8.01492 70.5009 8.01492C69.8686 8.01492 69.3381 8.22996 68.9018 8.65885C68.4669 9.08774 68.2463 9.63848 68.2463 10.3063C68.2463 10.9741 68.4669 11.5249 68.9018 11.9538Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.583 13.1713V7.44165H75.502L78.3594 11.8978H78.3925L78.3594 10.7963V7.44165H79.1154V13.1713H78.3263L75.3341 8.49535H75.301L75.3341 9.60162V13.1713H74.583Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2893 21.5386C64.9869 21.5386 63.1061 23.247 63.1061 25.6041C63.1061 27.9421 64.9869 29.6684 67.2893 29.6684C69.5965 29.6684 71.4774 27.9421 71.4774 25.6041C71.4774 23.247 69.5965 21.5386 67.2893 21.5386ZM67.2893 28.0675C66.026 28.0675 64.9391 27.0508 64.9391 25.6041C64.9391 24.1382 66.026 23.1395 67.2893 23.1395C68.5526 23.1395 69.6443 24.1382 69.6443 25.6041C69.6443 27.0508 68.5526 28.0675 67.2893 28.0675ZM58.1619 21.5386C55.8547 21.5386 53.9787 23.247 53.9787 25.6041C53.9787 27.9421 55.8547 29.6684 58.1619 29.6684C60.468 29.6684 62.3452 27.9421 62.3452 25.6041C62.3452 23.247 60.468 21.5386 58.1619 21.5386ZM58.1619 28.0675C56.8974 28.0675 55.8069 27.0508 55.8069 25.6041C55.8069 24.1382 56.8974 23.1395 58.1619 23.1395C59.4252 23.1395 60.5121 24.1382 60.5121 25.6041C60.5121 27.0508 59.4252 28.0675 58.1619 28.0675ZM47.3008 22.7847V24.5122H51.5318C51.4081 25.4775 51.0772 26.1871 50.5699 26.6817C49.9524 27.279 48.9905 27.9421 47.3008 27.9421C44.697 27.9421 42.6581 25.8932 42.6581 23.3545C42.6581 20.8158 44.697 18.767 47.3008 18.767C48.7087 18.767 49.7331 19.3034 50.4891 19.9987L51.7377 18.7813C50.6802 17.7969 49.2736 17.0407 47.3008 17.0407C43.7303 17.0407 40.7295 19.8732 40.7295 23.3545C40.7295 26.8358 43.7303 29.6684 47.3008 29.6684C49.2307 29.6684 50.6802 29.0519 51.8198 27.8955C52.9875 26.757 53.3514 25.1561 53.3514 23.8635C53.3514 23.462 53.3171 23.0929 53.2558 22.7847H47.3008ZM91.7133 24.1239C91.369 23.2147 90.3067 21.5386 88.1428 21.5386C85.9985 21.5386 84.2132 23.1861 84.2132 25.6041C84.2132 27.8811 85.9801 29.6684 88.3486 29.6684C90.2638 29.6684 91.369 28.5299 91.8236 27.8668L90.4023 26.9433C89.9281 27.6195 89.2823 28.0675 88.3486 28.0675C87.4211 28.0675 86.7557 27.653 86.3293 26.8358L91.9057 24.5862L91.7133 24.1239ZM86.0279 25.4775C85.9801 23.91 87.2765 23.1072 88.2053 23.1072C88.9331 23.1072 89.5507 23.462 89.7565 23.9698L86.0279 25.4775ZM81.4955 29.4211H83.3286V17.4743H81.4955V29.4211ZM78.4935 22.4442H78.4322C78.0205 21.9687 77.2351 21.5386 76.2402 21.5386C74.1522 21.5386 72.2432 23.3258 72.2432 25.6172C72.2432 27.8955 74.1522 29.6684 76.2402 29.6684C77.2351 29.6684 78.0205 29.2347 78.4322 28.7449H78.4935V29.3279C78.4935 30.8822 77.6419 31.7172 76.2683 31.7172C75.1484 31.7172 74.4536 30.9288 74.1669 30.2657L72.5728 30.9144C73.0323 31.992 74.249 33.3181 76.2683 33.3181C78.4175 33.3181 80.231 32.0852 80.231 29.0854V21.7859H78.4935V22.4442ZM76.397 28.0675C75.1337 28.0675 74.0763 27.0365 74.0763 25.6172C74.0763 24.1848 75.1337 23.1395 76.397 23.1395C77.6419 23.1395 78.6234 24.1848 78.6234 25.6172C78.6234 27.0365 77.6419 28.0675 76.397 28.0675ZM100.295 17.4743H95.9112V29.4211H97.7394V24.8945H100.295C102.326 24.8945 104.317 23.462 104.317 21.1838C104.317 18.9067 102.321 17.4743 100.295 17.4743ZM100.343 23.2327H97.7394V19.1361H100.343C101.708 19.1361 102.487 20.2412 102.487 21.1838C102.487 22.1085 101.708 23.2327 100.343 23.2327ZM111.644 21.5159C110.323 21.5159 108.95 22.0846 108.385 23.345L110.007 24.008C110.356 23.345 110.998 23.1299 111.677 23.1299C112.626 23.1299 113.588 23.6854 113.602 24.6663V24.7917C113.271 24.6053 112.563 24.3294 111.692 24.3294C109.945 24.3294 108.164 25.2672 108.164 27.0174C108.164 28.6183 109.595 29.6493 111.204 29.6493C112.435 29.6493 113.113 29.1081 113.54 28.4785H113.602V29.402H115.368V24.8192C115.368 22.701 113.746 21.5159 111.644 21.5159ZM111.424 28.0627C110.826 28.0627 109.992 27.7736 109.992 27.0508C109.992 26.1262 111.032 25.7713 111.931 25.7713C112.736 25.7713 113.113 25.9446 113.602 26.1728C113.459 27.279 112.482 28.0627 111.424 28.0627ZM121.801 21.7775L119.699 26.9565H119.637L117.464 21.7775H115.493L118.757 29.0149L116.895 33.0421H118.805L123.835 21.7775H121.801ZM105.322 29.4211H107.155V17.4743H105.322V29.4211Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7003_27507",
    x1: 21.8692,
    y1: 30.6544,
    x2: 5.83472,
    y2: 14.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7003_27507",
    x1: 33.6657,
    y1: 19.8624,
    x2: 9.94675,
    y2: 19.8624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7003_27507",
    x1: 24.8362,
    y1: 17.6692,
    x2: 3.09216,
    y2: -4.63238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7003_27507",
    x1: 7.6528,
    y1: 38.8102,
    x2: 17.3625,
    y2: 28.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleButton);
export default __webpack_public_path__ + "static/media/google-button.82ef36c3e9b53a2409c5fd32b7c4794b.svg";
export { ForwardRef as ReactComponent };